import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ByPassSecurityPipe } from './by-pass-security.pipe';

@NgModule({
    declarations: [ByPassSecurityPipe],
    imports: [
        CommonModule
    ],
    exports: [ByPassSecurityPipe]
})
export class ByPassSecurityModule { }
